import React from "react";
import Layout from "../components/Layout";
import { graphql, Link, PageProps } from "gatsby";
import { FunctionComponent } from "react";
import { RichText } from "prismic-reactjs";
import styled from "styled-components";
import SEO from "../components/seo";


const ContentWrapper = styled.div`
`;

const PostWrapper = styled.div`
  display: flex;
  flex-direction: column;
  
  max-width: 800px;
  
  
  img {
    max-width: 600px;
  }

  @media only screen and (max-width: 600px) {
    img {
      max-width: 90%;
    }
    max-width: 90%;

  }

`;

const PageButton = styled(Link)`
  border-radius: 5px;
  background-color: ${props => props.theme.colors.primary};
    //color:${props => props.theme.colors.primary};
  color: white;
  padding: 5px 10px;

  &:hover {
    color: ${props => props.theme.colors.secondary};
  }

  width: fit-content;
`;


export const pageQuery = graphql`
    query BlogPost($uid: String) {
        prismic {
            allArticles(uid: $uid) {
                edges {
                    node {
                        _meta {
                            id
                            uid
                            type
                            firstPublicationDate
                        }
                        title
                        content
                        description
                        image
                    }
                }
            }
        }
    }
`;

interface BlogPostPageProps extends PageProps {
    data: GatsbyTypes.BlogPostQuery
}

const BlogPostPage: FunctionComponent<BlogPostPageProps> = ({ data }) => {

    const doc = data.prismic.allArticles.edges?.slice(0, 1).pop();
    if (!doc) return null;

    const image = doc.node.image.url;

    return (
        <Layout>
            <SEO title={RichText.asText(doc.node.title)} description={RichText.asText(doc.node.description)} image={image}/>
            <PostWrapper>
                <h1>{RichText.asText(doc.node.title)}</h1>
                <h4>
                    {new Date(doc.node._meta.firstPublicationDate).toLocaleDateString("pl-PL", {
                        day: "numeric",
                        month: "long",
                        year: "numeric"
                    })}
                </h4>
                <ContentWrapper>
                    {RichText.render(doc.node.content)}
                </ContentWrapper>
                <PageButton to={"/"}>← Wróć</PageButton>
            </PostWrapper>
        </Layout>
    );
};

export default BlogPostPage;
